import React from 'react';
import colors from '@sizeid/assets/colors.json';

import { withTranslation } from 'lib/i18n';

import Item from './Item';
import Wrap from './styled/Wrap';
import { PriceItemProps } from './types';

const PriceItem: React.FC<PriceItemProps> = props => (
  <Wrap>
    {props.children ? (
      props.children
    ) : (
      <>
        <Item
          value={`${props.amount}`}
          unit={props.t('business.organizations.index.recommendation_unit')}
        />
        <Item
          value={props.price ?? ''}
          unit={
            props.priceUnit ||
            props.t('business.organizations.index.without_vac')
          }
          align="right"
          color={props.color || colors.SIDB.default}
          bold
        />
      </>
    )}
  </Wrap>
);

export default withTranslation('pages')(PriceItem);
